import { Record } from 'immutable';

const TradeInRecord = new Record({
    id: null,
    status: 0,
    leadId: null,
    tradeInVehicle: {
        id: '',
        make: '',
        model: '',
        trim: '',
        style: '',
        year: '',
        exteriorColor: {},
        interiorColor: {},
        vin: '',
        odometer: '',
        details: null,
    },
    estimation: {
        amount: 0,
        // For Dilawari we can get only unique amount, no High and low value
        high: 0,
        low: 0,
    },
    evaluationQuestion: {},
    profile: {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        optin: false,
    },
    info: null,
});

class TradeInModelNew extends TradeInRecord {}

export default TradeInModelNew;
